<template>
  <div id="app">
    <app-nav/>
    <router-view/>
  </div>
</template>

<script>
  import AppNav from './components/nav/AppNav.vue';

  export default {
    components: {
      AppNav,
    },
  };
</script>

<style lang="scss">
  // Customise bootstrap theme,
  // Find complete list in bootstrap/scss/_variables.scss.
  $primary: #4c00a4;
  $secondary: #CD4936;
  $success: #28a745;
  $info: #17a2b8;
  $warning: #ffc107;
  $danger: #dc3545;
  $light: #f8f9fa;
  $dark: #343a40;
  $backgroundColor: #f4f6f8;

  $border-radius: 4px;
  $input-border-radius: 4px;

  //noinspection CssUnknownTarget
  @import 'node_modules/bootstrap/scss/bootstrap';
  //noinspection CssUnknownTarget
  @import 'node_modules/bootstrap-vue/src/index.scss';
  //noinspection CssUnknownTarget
  @import url('~@/assets/css/fontawesome-all.min.css');

  html {
    background: $backgroundColor;
  }

  body {
    background: $backgroundColor;
  }

  .page-content {
    padding-top: 56px;
  }

  .content-container {
    background: white;
    border-radius: 4px;
  }

  .primary-text {
    color: $primary;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .success-text {
    color: $success;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .primary-color {
    color: $primary;
  }

  .success-color {
    color: $success
  }

  .danger-color {
    color: $danger;
  }

  .hover-danger {
    &:hover {
      color: $danger;
      cursor: pointer;
    }
  }

  .hover {
    cursor: pointer;
  }

  .hover-primary {
    &:hover {
      color: $primary;
    }
  }

  .no-padding {
    padding: 0px !important;
  }

  .vertical-center {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }

  .corner-close {
    position: absolute;
    top: 10px;
    right: 10px;
    transform: translate(-50%, 50%);
    color: grey;
    z-index: 1000;

    &:hover {
      color: black;
    }
  }

  .chameleon-hero-container {
    background: rgb(30, 130, 0);
    background: linear-gradient(315deg, darken($primary, 5) 45%, lighten($primary, 5) 100%);
    padding: 50px 0;
  }
</style>
